export default "{\n    \"label\": \"Equipo\"\n}"